import { render, staticRenderFns } from "./CardCredit.vue?vue&type=template&id=61564e6a&scoped=true"
import script from "./CardCredit.vue?vue&type=script&lang=js"
export * from "./CardCredit.vue?vue&type=script&lang=js"
import style0 from "./CardCredit.vue?vue&type=style&index=0&id=61564e6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61564e6a",
  null
  
)

export default component.exports